import { formatFechaSoloDiaDdMmYyyy } from './formatFechaSoloDia';

const UNIDADES = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
const DIEZ_A_DIECINUEVE = [
  'DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE',
  'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE',
];
const DECENAS = ['', '', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
const CENTENAS = [
  '', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS',
  'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS',
];

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

function convertirMenor1000(n) {
  if (n === 0) return '';
  if (n === 100) return 'CIEN';

  let resultado = '';
  const centenas = Math.floor(n / 100);
  const resto = n % 100;

  if (centenas > 0) resultado = CENTENAS[centenas];

  if (resto > 0) {
    const prefijo = resultado ? ' ' : '';
    if (resto < 10) {
      resultado += prefijo + UNIDADES[resto];
    } else if (resto < 20) {
      resultado += prefijo + DIEZ_A_DIECINUEVE[resto - 10];
    } else {
      const decenas = Math.floor(resto / 10);
      const unidades = resto % 10;
      resultado += prefijo + DECENAS[decenas];
      if (unidades > 0) resultado += ' Y ' + UNIDADES[unidades];
    }
  }

  return resultado;
}

/** Ej.: 12 → "DOCE" */
export function enteroALetras(n) {
  const numero = Math.floor(Math.abs(Number(n) || 0));
  if (numero === 0) return 'CERO';

  const millones = Math.floor(numero / 1_000_000);
  const miles = Math.floor((numero % 1_000_000) / 1000);
  const unidades = numero % 1000;
  const partes = [];

  if (millones > 0) {
    partes.push(millones === 1 ? 'UN MILLON' : `${convertirMenor1000(millones)} MILLONES`);
  }
  if (miles > 0) {
    partes.push(miles === 1 ? 'MIL' : `${convertirMenor1000(miles)} MIL`);
  }
  if (unidades > 0 || partes.length === 0) {
    partes.push(convertirMenor1000(unidades));
  }

  return partes.join(' ').replace(/\s+/g, ' ').trim();
}

/** Ej.: 538.5 → "QUINIENTOS TREINTA Y OCHO con 50/100 SOLES" */
export function montoLiquidacionEnLetras(monto) {
  const valor = Math.abs(Number(monto) || 0);
  const entero = Math.floor(valor);
  const centavos = Math.round((valor - entero) * 100);
  const centavosTxt = String(centavos).padStart(2, '0');
  return `${enteroALetras(entero)} con ${centavosTxt}/100 SOLES`;
}

/** Ej.: 1550 → "MIL QUINIENTOS CINCUENTA Y 00/100" */
export function montoContratoEnLetras(monto) {
  const valor = Math.abs(Number(monto) || 0);
  const entero = Math.floor(valor);
  const centavos = Math.round((valor - entero) * 100);
  const centavosTxt = String(centavos).padStart(2, '0');
  return `${enteroALetras(entero)} Y ${centavosTxt}/100`;
}

/** Ej.: "2026-02-16" → "16 de febrero del 2026" */
export function fechaLiquidacionEnLetras(fechaYmd) {
  const f = formatFechaSoloDiaDdMmYyyy(fechaYmd, '');
  if (!f) return '';
  const [d, m, y] = f.split('/');
  const mi = parseInt(m, 10) - 1;
  if (mi < 0 || mi > 11) return f;
  return `${parseInt(d, 10)} de ${MESES[mi]} del ${y}`;
}

/** Ej.: ciudad + fecha → "Arequipa, 16 de febrero del 2026" */
export function lineaLugarFechaLiquidacion(ciudad, fechaYmd) {
  const fecha = fechaLiquidacionEnLetras(fechaYmd);
  if (!fecha) return ciudad || '';
  const lugar = (ciudad || '').trim();
  return lugar ? `${lugar}, ${fecha}` : fecha;
}
